import React, { Component } from 'react'
import apiService from '../../services/ApiService'
import Select from 'react-select'

class Products extends Component {
    constructor() {
        super()
        this.state = {
            productsList: "",
        }
        this.isComponentStillMounted = true
    }

    componentDidMount() {
        this.getProductsList(this.props.type,this.props.city)
    }

    componentWillUnmount() {
        this.isComponentStillMounted = false
    }

    getProductsList = (type,city) => {
        apiService.getProductsList(type,city)
            .then(listData => {
                if (listData && this.isComponentStillMounted) {
                     this.setState({
                        productsList: listData.data
                    })
                    
                }
            })
            .catch(err => {
                console.error("Error data: ", err)
            })
    }

    render() {
        let list = {}
         list = Object.keys(this.state.productsList).map((value,index) => {
            return {
                label : this.state.productsList[value],
                value : value
            }
        })
        list.sort((a,b) => a.label.localeCompare(b.label));

        return (
            <div>
                <Select
                value={this.props.selectedValue}
                placeholder="Select Kit"
                options={list}
                onChange={(e) => { (e) ? this.props.productsChange(e) : this.props.productsChange([])}}
                />
            </div>
        )
    }
}
export default Products


// WEBPACK FOOTER //
// ./src/common/DropDowns/Products.js